import {O1BoxGroup} from "../managers/o1BoxManager";
import executeInEditMode = cc._decorator.executeInEditMode;
import {managers} from "../gameEngine";
import {Direction} from "../../modes/fpsMode/fpsMode";

const {ccclass, property, menu} = cc._decorator;

@ccclass
@menu("框架组件/简单碰撞")
@executeInEditMode()
export default class comO1Box extends cc.Component {
    @property({tooltip: '分组及分组碰撞需要代码添加', type: cc.Enum(O1BoxGroup)})
    boxGroup: O1BoxGroup = O1BoxGroup.NORMAL;
    @property({tooltip: '开启碰撞回调'})
    isCollisionCallback: boolean = false;
    @property({tooltip: '只有动态的物品才可以动'})
    isDynamic: boolean = false;
    @property({tooltip: '重力缩放'})
    gravity: number = 1;
    @property({tooltip: '线性速度 唯一驱动'})
    protected lineVelocity: cc.Vec2 = cc.v2(0, 0);
    @property({tooltip: '标记号'})
    tag: number = 0;

    public id: string;
    //
    protected m_goDirection: Direction = null;
    //预先线性速度
    protected m_predictLineVelocity: cc.Vec2[] = [];
    //预先位置
    protected m_predictPos: cc.Vec2[] = [];

    start(): void {
        this.m_predictPos = [];
        this.m_predictLineVelocity = [];
    }

    setGoDirection(go: Direction) {
        this.m_goDirection = go;
    }

    getGoDirection() {
        return this.m_goDirection;
    }

    getProductLastLineVelocity() {
        if (this.m_predictLineVelocity.length > 0) {
            return this.m_predictLineVelocity[this.m_predictLineVelocity.length - 1];
        }
        return this.lineVelocity;
    }

    pushPredictLineVelocity(vec2: cc.Vec2) {
        this.m_predictLineVelocity.push(vec2);
    }

    pushLastPredictLineVelocity() {
        this.pushPredictLineVelocity(this.getProductLastLineVelocity().clone());
    }

    clearPredictLineVelocity() {
        this.m_predictLineVelocity.length = 0;
    }

    onTimerRunSync() {
        if (this.m_predictLineVelocity.length > 0) {
            this.lineVelocity = this.m_predictLineVelocity.shift();
        }
        if (this.m_predictPos.length > 0) {
            this.node.setPosition(this.m_predictPos.shift().clone());
        }
    }

    isHaveLastPos(): boolean {
        return this.m_predictLineVelocity.length > 0 || this.m_predictPos.length > 0;
    }

    getPredictLastPos() {
        if (this.m_predictPos.length > 0) {
            return this.m_predictPos[this.m_predictPos.length - 1];
        }
        return this.node.getPosition();
    }

    pushPredictPos(vec2: cc.Vec2) {
        this.m_predictPos.push(vec2);
    }

    pushLastPredictPos() {
        this.pushPredictPos(this.getPredictLastPos().clone());
        // if (this.m_predictPos.length > 0) {
        // console.debug('位置变量', this.m_predictPos.length);
        // this.m_predictPos.forEach(p => {
        //     console.debug(p.x, p.y);
        // });
        // }
    }

    clearPredictPoss() {
        this.m_predictPos.length = 0;
    }

    protected onEnable() {
        managers().o1BoxMgr.addBox(this);
    }

    protected onDisable() {
        managers().o1BoxMgr.deleteBox(this);
    }

    //碰撞被碰撞回调
    onCollisionBox(other: comO1Box) {
        console.debug('碰到了', '我', this, '其他', other);
    }

    onCollisionBoxLearn(other: comO1Box) {
        console.debug('离开了', '我', this, '其他', other);
    }

    onUpdateLogicStart() {
        const go = this.getGoDirection();
        const lineVelocity = this.getProductLastLineVelocity();
        switch (go) {
            case Direction.LEFT: {
                lineVelocity.x = -1 / 2;
                break;
            }
            case Direction.RIGHT: {
                lineVelocity.x = 1 / 2;
                break;
            }
            default: {
                lineVelocity.x = 0;
                break;
            }
        }
    }

    onUpdateLogicEnd() {

    }

    protected update(dt: number) {
    }
}






































